// extracted by mini-css-extract-plugin
export var container = "_t6-0";
export var table = "_t6-2";
export var tableWrapper = "_t6-1";